// extracted by mini-css-extract-plugin
export default {"root":"style_root__7CDgq","icon":"style_icon__NFsrS","text":"style_text__oqfu-","accent":"style_accent__5J8pn"};